<template>
  <v-dialog
    v-model="dialog"
    max-width="1050px"
    scrollable
    persistent
    @click:outside="cerrarDialogo(false)"
  >
    <v-card class="rounded-lg elevation-3 overflow-hidden">
      <!-- Toolbar Header -->
      <!-- Toolbar Header -->
      <v-toolbar
        color="secondary"
        dark
        flat
        class="table-header-toolbar px-2 px-sm-4"
      >
        <div
          class="d-flex align-center header-main-info flex-grow-1 min-width-0"
        >
          <div class="header-icon-box mr-2 mr-sm-3 flex-shrink-0">
            <v-icon color="white">mdi-clipboard-check-outline</v-icon>
          </div>
          <div class="header-text-block min-width-0 mr-2">
            <div class="header-company-title font-weight-bold text-truncate">
              {{
                Item.id == null
                  ? "Inspección de neumático"
                  : "Editar inspección"
              }}
            </div>
          </div>
          <div
            class="d-flex align-center flex-wrap gap-2 flex-shrink-0 header-chips-group"
          >
            <v-chip
              v-if="Item.id || Item.id_neumaticos"
              small
              color="white"
              text-color="secondary"
              class="header-count-chip font-weight-bold elevation-1"
            >
              <v-icon left size="14" color="secondary">mdi-pound</v-icon>
              ID: {{ Item.id || Item.id_neumaticos }}
            </v-chip>
            <v-chip
              v-if="Item.d_posicion"
              small
              color="white"
              text-color="secondary"
              class="header-count-chip font-weight-bold elevation-1"
            >
              <v-icon left size="14" color="secondary"
                >mdi-map-marker-outline</v-icon
              >
              Pos: {{ Item.d_posicion }}
            </v-chip>
            <v-chip
              v-if="Item.num_serie"
              small
              color="white"
              text-color="secondary"
              class="header-count-chip font-weight-bold elevation-1"
            >
              <v-icon left size="14" color="secondary">mdi-barcode-scan</v-icon>
              {{ Item.num_serie }}
            </v-chip>
          </div>
        </div>

        <div class="header-help-btn ml-1 ml-sm-2 flex-shrink-0">
          <v-btn icon dark small @click="cerrarDialogo(false)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </v-toolbar>

      <!-- ── Notification Banner ── -->
      <transition name="notif-slide">
        <div
          v-if="notification.visible"
          class="insp-notification"
          :class="'insp-notification--' + notification.type"
        >
          <v-icon class="insp-notification__icon" size="20">
            {{
              notification.type === "error"
                ? "mdi-alert-circle"
                : notification.type === "warning"
                ? "mdi-alert"
                : "mdi-check-circle"
            }}
          </v-icon>
          <div class="insp-notification__body">
            <span class="insp-notification__title">{{
              notification.title
            }}</span>
            <span
              class="insp-notification__msg"
              v-html="notification.message"
            ></span>
            <div
              v-if="notification.actionLabel"
              class="insp-notification__action"
            >
              <button
                class="insp-notification__action-btn"
                @click="notification.actionFn && notification.actionFn()"
              >
                {{ notification.actionLabel }}
              </button>
            </div>
          </div>
          <button
            class="insp-notification__close"
            @click="notification.visible = false"
          >
            <v-icon size="16">mdi-close</v-icon>
          </button>
        </div>
      </transition>

      <v-card-text class="pa-3 pa-sm-5" style="max-height: 78vh">
        <v-form enctype="multipart/form-data" ref="form" v-model="valid">
          <!-- SECCIÓN 1: Datos Generales y Presión -->
          <div class="mb-4">
            <div class="panel-header mb-3">
              <v-icon small color="white" class="mr-2">mdi-gauge</v-icon>
              <span class="panel-title">Datos Generales y Presión</span>
            </div>
            <v-row dense>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  label="Posición *"
                  v-model="Item.d_posicion"
                  outlined
                  dense
                  readonly
                  prepend-inner-icon="mdi-map-marker-outline"
                  hide-details="auto"
                  :rules="[
                    (v) => !!v || !!Item.posicion || 'Posición es requerida',
                  ]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  label="Nro. Serie del Neumático *"
                  v-model="Item.num_serie"
                  outlined
                  dense
                  readonly
                  prepend-inner-icon="mdi-barcode"
                  hide-details="auto"
                  :rules="[
                    (v) =>
                      (!!v && !!String(v).trim()) ||
                      'Nro. de serie es requerido',
                  ]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4" class="mt-4">
                <div class="d-flex align-center">
                  <v-autocomplete
                    :items="Ejes"
                    v-model="Item.id_ejes"
                    label="Seleccionar Eje *"
                    outlined
                    dense
                    prepend-inner-icon="mdi-ray-vertex"
                    :readonly="habilitareje"
                    :rules="[(v) => !!v || 'Eje es requerido']"
                    @change="onEjes"
                    hide-details="auto"
                    class="flex-grow-1"
                  ></v-autocomplete>
                  <v-tooltip top v-if="habilitareje">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        color="success"
                        height="38"
                        width="38"
                        class="ml-2 elevation-1 flex-shrink-0"
                        small
                        v-on="on"
                        @click="habilitareje = false"
                      >
                        <v-icon small>mdi-lock-open-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Desbloquear eje</span>
                  </v-tooltip>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="4" class="mt-4">
                <v-autocomplete
                  :items="tiposPresion"
                  v-model="Item.tipo_presion"
                  label="Tipo de presión *"
                  outlined
                  dense
                  prepend-inner-icon="mdi-scale"
                  hide-details="auto"
                  :rules="[(v) => !!v || 'Tipo de presión es requerido']"
                ></v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
                class="mt-4"
                v-if="Item.accesibilidad != 0"
              >
                <v-text-field
                  type="number"
                  min="0"
                  label="Presión actual *"
                  v-model="Item.presion"
                  outlined
                  dense
                  suffix="PSI"
                  prepend-inner-icon="mdi-gauge"
                  hide-details="auto"
                  :rules="rulesPresionActual"
                  hint="(rec. <= 160 PSI)"
                  persistent-hint
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="mt-4" v-else>
                <v-text-field
                  type="number"
                  label="Presión actual"
                  v-model="Item.presion"
                  outlined
                  dense
                  suffix="PSI"
                  prepend-inner-icon="mdi-gauge"
                  hide-details="auto"
                  hint="(rec. <= 160 PSI)"
                  persistent-hint
                  readonly
                ></v-text-field>
              </v-col>
            </v-row>
          </div>

          <v-divider class="my-4"></v-divider>

          <!-- SECCIÓN 2: Componentes Técnicos y Medición -->
          <v-row dense>
            <!-- Card 1: Tapa de Pitón y Accesibilidad -->
            <v-col cols="12" md="6">
              <v-card outlined class="rounded-lg fill-height pa-3 card-panel">
                <div class="panel-header mb-3">
                  <v-icon small color="white" class="mr-2">mdi-valve</v-icon>
                  <span class="panel-title">Tapa de Pitón y Accesibilidad</span>
                </div>
                <v-row dense>
                  <v-col cols="12" sm="12">
                    <v-autocomplete
                      :items="TiposValvula"
                      v-model="Item.valvula"
                      label="Válvula *"
                      outlined
                      dense
                      prepend-inner-icon="mdi-valve"
                      hide-details="auto"
                      :rules="[(v) => !!v || 'Tapa es requerida']"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-autocomplete
                      :items="accesibilidad"
                      v-model="Item.accesibilidad"
                      label="Accesibilidad *"
                      outlined
                      dense
                      prepend-inner-icon="mdi-eye-check-outline"
                      hide-details="auto"
                      :rules="[
                        (v) =>
                          (v !== null && v !== undefined && v !== '') ||
                          'Accesibilidad es requerida',
                      ]"
                      @change="onAccesibilidad"
                    ></v-autocomplete>
                  </v-col>
                  <v-col
                    cols="12"
                    class="mt-2"
                    v-if="Item.accesibilidad == '0'"
                  >
                    <div class="d-flex align-center">
                      <v-autocomplete
                        :items="MotivosInaccesibilidad"
                        v-model="Item.motivo_inaccesibilidad"
                        label="Motivo de inaccesibilidad *"
                        outlined
                        dense
                        prepend-inner-icon="mdi-alert-circle-outline"
                        hide-details="auto"
                        :rules="[(v) => !!v || 'Motivo es requerido']"
                        class="flex-grow-1 mr-2"
                      ></v-autocomplete>
                      <v-tooltip top v-if="puedeAgregar">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="primary"
                            height="38"
                            width="38"
                            class="elevation-1 flex-shrink-0"
                            small
                            v-bind="attrs"
                            v-on="on"
                            @click="
                              abrirModalNuevaObs(
                                'I',
                                'Motivo de Inaccesibilidad',
                              )
                            "
                          >
                            <v-icon small>mdi-plus</v-icon>
                          </v-btn>
                        </template>
                        <span>Agregar nuevo motivo</span>
                      </v-tooltip>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>

            <!-- Card 2: Profundidad de Rodado (mm) -->
            <v-col cols="12" md="6">
              <v-card outlined class="rounded-lg fill-height pa-3 card-panel">
                <div class="panel-header mb-3">
                  <v-icon small color="white" class="mr-2">mdi-ruler</v-icon>
                  <span class="panel-title">Profundidad de Rodado (mm)</span>
                </div>

                <!-- Switch: Omitir la verificación de rodado -->
                <div
                  class="d-flex align-center justify-space-between px-3 py-1 mb-3 rounded-lg border-subcard"
                >
                  <div class="d-flex align-center" style="gap: 4px">
                    <v-tooltip bottom max-width="260">
                      <template #activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          size="15"
                          color="grey darken-1"
                          style="cursor: help"
                          >mdi-information-outline</v-icon
                        >
                      </template>
                      <span>
                        Úsala para desactivar el control de rodado y guardar la
                        inspección libremente cuando la medición del neumático
                        haya cambiado por reencauche, rotación o remontaje.
                      </span>
                    </v-tooltip>
                    <span
                      class="text-caption font-weight-bold grey--text text--darken-2"
                    >
                      Omitir la verificación de rodado
                    </span>
                  </div>
                  <v-switch
                    v-model="ajusteDesgaste"
                    color="primary"
                    dense
                    hide-details
                    class="mt-0 pt-0"
                    @change="onCambioAjusteDesgaste"
                  ></v-switch>
                </div>

                <v-row dense>
                  <v-col cols="12" sm="12">
                    <v-text-field
                      type="number"
                      step="any"
                      min="0"
                      label="Izquierdo *"
                      v-model="Item.exterior"
                      outlined
                      dense
                      suffix="mm"
                      hide-details="auto"
                      @blur="onValidarRemanente('exterior')"
                      @change="onValidarRemanente('exterior')"
                      @input="onInputExterior"
                      :rules="rulesProfundidadIzquierda"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-text-field
                      type="number"
                      step="any"
                      min="0"
                      label="Medio"
                      v-model="Item.medio"
                      outlined
                      dense
                      suffix="mm"
                      hide-details="auto"
                      @blur="onValidarRemanente('')"
                      @input="onLimitarDecimales('medio')"
                      :rules="[
                        (v) =>
                          v === null ||
                          v === undefined ||
                          v === '' ||
                          Number(v) >= 0 ||
                          'Debe ser mayor o igual a 0',
                        (v) =>
                          v === null ||
                          v === undefined ||
                          v === '' ||
                          Number(v) <= 125 ||
                          'Debe ser <= 125',
                        (v) => {
                          if (v === null || v === undefined || v === '')
                            return true;
                          const pattern = /^\d{1,3}([\.,]\d{1,2})?$/;
                          return (
                            pattern.test(v) || 'Máx 3 enteros y 2 decimales'
                          );
                        },
                      ]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-text-field
                      type="number"
                      step="any"
                      min="0"
                      label="Derecho *"
                      v-model="Item.interior"
                      outlined
                      dense
                      suffix="mm"
                      hide-details="auto"
                      @blur="onValidarRemanente('interior')"
                      @change="onValidarRemanente('interior')"
                      @input="onInputInterior"
                      :rules="rulesProfundidadDerecha"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>

            <!-- Card 3: Duales mal hermanados -->
            <v-col cols="12" md="6">
              <v-card outlined class="rounded-lg fill-height pa-3 card-panel">
                <div class="panel-header mb-2">
                  <v-icon small color="white" class="mr-2"
                    >mdi-vector-combine</v-icon
                  >
                  <span class="panel-title">Duales mal hermanados</span>
                </div>
                <div
                  v-if="mensajeejedireccional"
                  class="red--text caption font-weight-bold mb-2"
                >
                  <v-icon x-small color="red" class="mr-1"
                    >mdi-alert-circle</v-icon
                  >
                  {{ mensajeejedireccional }}
                </div>
                <v-row dense>
                  <v-col cols="12" sm="6">
                    <v-checkbox
                      v-if="Duales && Duales[0]"
                      v-model="Duales[0].opcion"
                      label="Diseño"
                      color="primary"
                      dense
                      hide-details
                      class="mt-1"
                      @change="onDualesMalHermanados1"
                      :readonly="inhabilitarradio"
                    ></v-checkbox>
                    <v-checkbox
                      v-if="Duales && Duales[1]"
                      v-model="Duales[1].opcion"
                      label="Tamaño"
                      color="primary"
                      dense
                      hide-details
                      class="mt-1"
                      @change="onDualesMalHermanados1"
                      :readonly="inhabilitarradio"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-checkbox
                      v-if="Duales && Duales[2]"
                      v-model="Duales[2].opcion"
                      label="Tipo de construcción"
                      color="primary"
                      dense
                      hide-details
                      class="mt-1"
                      @change="onDualesMalHermanados1"
                      :readonly="inhabilitarradio"
                    ></v-checkbox>
                    <v-checkbox
                      v-if="Duales && Duales[3]"
                      v-model="Duales[3].opcion"
                      label="Medida de neumático"
                      color="primary"
                      dense
                      hide-details
                      class="mt-1"
                      @change="onDualesMalHermanados1"
                      :readonly="inhabilitarradio"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="12">
                    <v-divider class="my-2"></v-divider>
                    <v-checkbox
                      v-if="Duales && Duales[4]"
                      v-model="Duales[4].opcion"
                      label="No aplica"
                      color="primary"
                      dense
                      hide-details
                      class="mt-0"
                      @change="onDualesMalHermanados2"
                      :readonly="inhabilitarradio"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>

            <!-- Card 4: Separación entre Duales -->
            <v-col cols="12" md="6">
              <v-card outlined class="rounded-lg fill-height pa-3 card-panel">
                <div class="panel-header mb-2">
                  <v-icon small color="white" class="mr-2"
                    >mdi-arrow-split-vertical</v-icon
                  >
                  <span class="panel-title">Separación entre Duales</span>
                </div>
                <div
                  v-if="mensajeejedireccional"
                  class="red--text caption font-weight-bold mb-2"
                >
                  <v-icon x-small color="red" class="mr-1"
                    >mdi-alert-circle</v-icon
                  >
                  {{ mensajeejedireccional }}
                </div>
                <v-radio-group v-model="Item.sep_duales" column class="mt-1">
                  <v-radio
                    label="Ok"
                    color="primary"
                    value="Sep. Entre Duales- Ok"
                    :readonly="inhabilitarseparacion"
                  ></v-radio>
                  <v-radio
                    label="Muy Juntos"
                    color="primary"
                    value="Sep. Entre Duales- Muy Juntos"
                    :readonly="inhabilitarseparacion"
                  ></v-radio>
                  <v-radio
                    label="Muy Separados"
                    color="primary"
                    value="Sep. Entre Duales- Muy Separados"
                    :readonly="inhabilitarseparacion"
                  ></v-radio>
                  <v-radio
                    label="No Aplica"
                    color="primary"
                    value="Sep. Entre Duales- No Aplica"
                    :readonly="inhabilitarseparacion"
                  ></v-radio>
                </v-radio-group>
              </v-card>
            </v-col>

            <!-- Card 5: Observaciones -->
            <v-col cols="12" md="6" class="align-self-start">
              <v-card outlined class="rounded-lg pa-3 card-panel">
                <div class="panel-header mb-2">
                  <v-icon small color="white" class="mr-2"
                    >mdi-clipboard-alert-outline</v-icon
                  >
                  <span class="panel-title">Observaciones</span>
                </div>
                <div class="obs-scroll-container">
                  <div
                    v-for="(obs, idx) in ListaTodasObservaciones"
                    :key="'obs_' + idx"
                    class="mb-2 pa-2 rounded-lg border-subcard"
                  >
                    <div class="d-flex align-center justify-space-between">
                      <v-checkbox
                        v-model="opcionesObs[obs.identificador]"
                        @change="onObservaciones"
                        :label="obs.label"
                        color="primary"
                        dense
                        hide-details
                        class="mt-0 pt-0"
                      ></v-checkbox>
                      <v-btn
                        v-if="puedeAgregar && obs.tipo === 'con_items'"
                        icon
                        x-small
                        class="btn-item-row ml-1"
                        :title="'Agregar ítem para ' + obs.label"
                        @click="
                          abrirModalNuevaObs(obs.identificador, obs.label)
                        "
                      >
                        <v-icon x-small>mdi-plus</v-icon>
                      </v-btn>
                    </div>

                    <div
                      v-if="
                        obs.tipo === 'con_items' &&
                        !!opcionesObs[obs.identificador]
                      "
                      class="mt-2"
                    >
                      <v-autocomplete
                        v-if="!obs.isCustom"
                        class="flex-grow-1"
                        :items="obs.items"
                        v-model="Item[obs.vModelKey]"
                        placeholder="Seleccione opciones..."
                        :multiple="obs.multiple"
                        outlined
                        dense
                        hide-details="auto"
                        @change="validacionObservaciones"
                      ></v-autocomplete>
                      <v-autocomplete
                        v-else
                        class="flex-grow-1"
                        :items="obs.items"
                        v-model="Item[obs.vModelKey]"
                        placeholder="Seleccione opción..."
                        outlined
                        dense
                        hide-details="auto"
                      ></v-autocomplete>
                    </div>

                    <span
                      v-if="obs.mensajeError"
                      class="red--text caption font-weight-medium d-block mt-1"
                    >
                      {{ obs.mensajeError }}
                    </span>
                  </div>
                </div>
              </v-card>
            </v-col>

            <!-- Card 6: Estado y Evidencia Fotográfica -->
            <v-col cols="12" md="6" class="align-self-start">
              <v-card outlined class="rounded-lg pa-3 card-panel">
                <div class="panel-header mb-2">
                  <v-icon small color="white" class="mr-2"
                    >mdi-traffic-light</v-icon
                  >
                  <span class="panel-title">Estado del Neumático *</span>
                </div>
                <div
                  v-if="mensajeestadoneumatico"
                  class="red--text caption font-weight-bold mb-2"
                >
                  <v-icon x-small color="red" class="mr-1"
                    >mdi-alert-circle</v-icon
                  >
                  {{ mensajeestadoneumatico }}
                </div>
                <v-radio-group
                  v-model="Item.estado"
                  column
                  class="mt-2"
                  hide-details="auto"
                  :rules="[
                    (v) => !!v || 'Debe seleccionar el estado del neumático',
                  ]"
                >
                  <div class="mb-2 pa-2 rounded-lg border-subcard">
                    <v-radio
                      label="Continuar en Operación"
                      color="success"
                      value="Continuar en Operación"
                      hide-details
                      dense
                      class="mt-0 pt-0"
                    ></v-radio>
                  </div>
                  <div class="mb-2 pa-2 rounded-lg border-subcard">
                    <v-radio
                      label="Lista para Reencauchar"
                      color="warning"
                      value="Lista para Reencauchar"
                      hide-details
                      dense
                      class="mt-0 pt-0"
                    ></v-radio>
                  </div>
                  <div class="mb-2 pa-2 rounded-lg border-subcard">
                    <v-radio
                      label="Lista para Reemplazar"
                      color="error"
                      value="Lista para Reemplazar"
                      hide-details
                      dense
                      class="mt-0 pt-0"
                    ></v-radio>
                  </div>
                  <div class="mb-2 pa-2 rounded-lg border-subcard">
                    <v-radio
                      label="Neumático en Mal estado"
                      color="error"
                      value="Neumático en Mal estado"
                      hide-details
                      dense
                      class="mt-0 pt-0"
                    ></v-radio>
                  </div>
                </v-radio-group>

                <!-- Subir Evidencia Fotográfica (Mal Estado o Reemplazar) -->
                <template
                  v-if="
                    Item.estado == 'Lista para Reemplazar' ||
                    Item.estado == 'Neumático en Mal estado'
                  "
                >
                  <v-divider class="my-3"></v-divider>
                  <div class="d-flex align-center justify-space-between mb-2">
                    <div class="d-flex align-center">
                      <v-icon small color="primary" class="mr-1"
                        >mdi-camera</v-icon
                      >
                      <span
                        class="font-weight-bold text-caption text-uppercase"
                      >
                        Fotografía de Mal Estado
                      </span>
                    </div>
                    <v-chip
                      x-small
                      :color="
                        previewLocal1
                          ? 'info'
                          : Item.neumaticoimgruta1
                          ? 'success'
                          : 'grey lighten-2'
                      "
                      :text-color="
                        previewLocal1 || Item.neumaticoimgruta1
                          ? 'white'
                          : 'grey darken-2'
                      "
                      class="font-weight-bold"
                    >
                      {{
                        previewLocal1
                          ? "Por guardar"
                          : Item.neumaticoimgruta1
                          ? "Foto guardada"
                          : "Sin imagen"
                      }}
                    </v-chip>
                  </div>

                  <FileAgent
                    ref="fileAgent"
                    :autoUpload="false"
                    @archivosubido="archivosubido"
                    style="z-index: 0"
                  />

                  <div
                    class="preview-box mt-3 d-flex align-center justify-center"
                  >
                    <template v-if="previewLocal1">
                      <img
                        :src="previewLocal1"
                        alt="Nueva Foto"
                        class="preview-img"
                      />
                    </template>
                    <template v-else-if="Item.neumaticoimgruta1">
                      <img
                        :src="ruta + Item.neumaticoimgruta1"
                        alt="Foto Actual"
                        class="preview-img"
                      />
                    </template>
                    <div v-else class="empty-state">
                      <v-icon large color="grey lighten-1"
                        >mdi-image-off-outline</v-icon
                      >
                      <span class="text-caption grey--text text--darken-1 mt-1">
                        Imagen no disponible
                      </span>
                    </div>
                  </div>
                </template>
              </v-card>
            </v-col>

            <!-- Card 7: Estado de tuercas -->
            <v-col cols="12" md="6">
              <v-card outlined class="rounded-lg fill-height pa-3 card-panel">
                <div class="panel-header mb-3">
                  <v-icon small color="white" class="mr-2">mdi-nut</v-icon>
                  <span class="panel-title">Estado de Tuercas</span>
                </div>
                <v-row dense>
                  <v-col cols="12" sm="7">
                    <div class="d-flex align-center">
                      <v-autocomplete
                        :items="listEstadosTuerca"
                        v-model="Item.tuercaestado"
                        label="Estado de tuerca *"
                        outlined
                        dense
                        prepend-inner-icon="mdi-nut"
                        hide-details="auto"
                        :rules="[(v) => !!v || 'Estado de tuerca es requerido']"
                        @change="onEstadoTuerca"
                        class="flex-grow-1 mr-2"
                      ></v-autocomplete>
                      <v-tooltip top v-if="puedeAgregar">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="primary"
                            height="38"
                            width="38"
                            class="elevation-1 flex-shrink-0"
                            small
                            v-bind="attrs"
                            v-on="on"
                            @click="
                              abrirModalNuevaObs('TE', 'Estado de Tuerca')
                            "
                          >
                            <v-icon small>mdi-plus</v-icon>
                          </v-btn>
                        </template>
                        <span>Agregar nuevo estado</span>
                      </v-tooltip>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="5">
                    <v-text-field
                      type="number"
                      min="0"
                      label="Cantidad tuercas"
                      v-model="Item.tuercacantidad"
                      outlined
                      dense
                      prepend-inner-icon="mdi-numeric"
                      hide-details="auto"
                      :rules="rulesCantidadTuercasComputed"
                      :readonly="Item.tuercaestado == 1"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>

            <!-- Card 8: Recomendación -->
            <v-col cols="12" md="6">
              <v-card outlined class="rounded-lg fill-height pa-3 card-panel">
                <div class="panel-header mb-3">
                  <v-icon small color="white" class="mr-2"
                    >mdi-comment-text-outline</v-icon
                  >
                  <span class="panel-title">Recomendación Técnica</span>
                </div>
                <v-textarea
                  v-model="Item.recomendacion"
                  label="Recomendación *"
                  outlined
                  dense
                  rows="2"
                  auto-grow
                  counter="300"
                  maxlength="300"
                  prepend-inner-icon="mdi-comment-edit-outline"
                  placeholder="Ingrese recomendaciones de la inspección..."
                  hide-details="auto"
                  :rules="[
                    (v) =>
                      (!!v && !!String(v).trim()) ||
                      'Recomendación es requerida',
                  ]"
                ></v-textarea>
              </v-card>
            </v-col>
          </v-row>

          <div class="mt-3 caption grey--text text--darken-1">
            <span class="red--text font-weight-bold">*</span> Datos obligatorios
          </div>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <!-- Footer Actions -->
      <v-card-actions class="pa-4 bg-actions form-card-actions">
        <v-spacer class="d-none d-sm-flex"></v-spacer>
        <v-btn
          outlined
          color="grey darken-2"
          class="btn-form-action px-5 text-capitalize font-weight-bold"
          @click="cerrarDialogo(false)"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="info"
          :loading="loading"
          :disabled="loading"
          class="btn-form-action px-6 text-capitalize font-weight-bold elevation-1"
          @click="agregar()"
        >
          <v-icon left small>mdi-content-save</v-icon>
          {{ Item.id == null ? "Guardar Inspección" : "Actualizar Inspección" }}
        </v-btn>
      </v-card-actions>
      <MensajeTransicion
        :color="color"
        :text="mensaje"
        v-if="verAlerta"
        :top="false"
        :bottom="true"
      />

      <!-- Modal para Agregar Nueva Observación / Sub-ítems -->
      <v-dialog v-model="dialogNuevaObs" max-width="520px" persistent>
        <v-card class="rounded-lg overflow-hidden elevation-12">
          <!-- Cabecera con Degradado Moderno -->
          <div class="modal-header-gradient px-4 py-3 d-flex align-center">
            <v-avatar color="rgba(255,255,255,0.2)" size="38" class="mr-3">
              <v-icon color="white" small>{{
                esAgregarItemASelector
                  ? "mdi-playlist-plus"
                  : "mdi-text-box-plus-outline"
              }}</v-icon>
            </v-avatar>
            <div>
              <div
                class="text-subtitle-1 font-weight-bold white--text line-height-1"
              >
                {{ nuevaObsTitulo }}
              </div>
              <div class="caption white--text text--lighten-4">
                {{
                  esAgregarItemASelector
                    ? "Añade una o más opciones a la lista"
                    : "Registra una observación para las inspecciones"
                }}
              </div>
            </div>
            <v-spacer></v-spacer>
            <v-btn
              icon
              dark
              x-small
              class="close-btn-hover"
              @click="dialogNuevaObs = false"
            >
              <v-icon small>mdi-close</v-icon>
            </v-btn>
          </div>

          <v-card-text class="pa-5">
            <!-- Modo 1: Crear Observación General Nueva -->
            <template v-if="!esAgregarItemASelector">
              <div class="mb-4">
                <label
                  class="text-caption font-weight-bold grey--text text--darken-2 d-block mb-1"
                >
                  NOMBRE DE LA OBSERVACIÓN <span class="red--text">*</span>
                </label>
                <v-text-field
                  v-model="nuevaObsTexto"
                  placeholder="Ej: ARO DEFECTUOSO / CORTE EN BANDA"
                  outlined
                  dense
                  hide-details="auto"
                  autofocus
                  prepend-inner-icon="mdi-label-outline"
                  @keyup.enter="guardarNuevaObs()"
                ></v-text-field>
              </div>

              <!-- Card interactivo para activar sub-ítems -->
              <div class="border-card pa-3 mb-4 rounded-lg bg-light-blue">
                <div class="d-flex align-center justify-space-between">
                  <div class="pr-2">
                    <div
                      class="body-2 font-weight-bold grey--text text--darken-3"
                    >
                      ¿Incluye opciones desplegables?
                    </div>
                    <div class="caption grey--text">
                      Permite seleccionar opciones específicas al elegir la
                      observación.
                    </div>
                  </div>
                  <v-switch
                    v-model="tieneSubItemsCheck"
                    color="primary"
                    hide-details
                    class="mt-0 pt-0"
                  ></v-switch>
                </div>
              </div>

              <!-- Sección de Lista de Sub-ítems (si tieneSubItemsCheck es true) -->
              <div
                v-if="tieneSubItemsCheck"
                class="border-card pa-3 rounded-lg"
              >
                <div class="d-flex align-center justify-space-between mb-2">
                  <span
                    class="text-caption font-weight-bold grey--text text--darken-2"
                    >OPCIONES DESPLEGABLES</span
                  >
                  <v-chip x-small color="primary" class="font-weight-bold px-2">
                    {{ nuevaObsItems.length }} agregados
                  </v-chip>
                </div>

                <div class="d-flex align-center mb-2">
                  <v-text-field
                    v-model="nuevaSubItemInput"
                    placeholder="Ej: BANDA, HOMBRO, SECTOR"
                    outlined
                    dense
                    hide-details
                    prepend-inner-icon="mdi-plus-circle-outline"
                    class="flex-grow-1"
                    @keyup.enter="agregarSubItem"
                  ></v-text-field>
                  <v-btn
                    color="primary"
                    depressed
                    small
                    class="ml-2 font-weight-bold text-capitalize px-3"
                    @click="agregarSubItem"
                  >
                    <v-icon small left>mdi-plus</v-icon> Agregar
                  </v-btn>
                </div>

                <div class="caption grey--text text--darken-2 mb-2 px-1">
                  Presiona la tecla
                  <kbd
                    class="px-2 py-0 grey lighten-2 black--text rounded font-weight-bold"
                    >Enter ↵</kbd
                  >
                  para agregar cada opción.
                </div>

                <!-- Chips agregados -->
                <div
                  v-if="nuevaObsItems.length > 0"
                  class="d-flex flex-wrap mt-2 pt-1 border-top-light"
                >
                  <v-chip
                    v-for="(item, idx) in nuevaObsItems"
                    :key="idx"
                    close
                    small
                    color="primary"
                    outlined
                    class="ma-1 font-weight-medium"
                    @click:close="eliminarSubItem(idx)"
                  >
                    {{ item }}
                  </v-chip>
                </div>
              </div>
            </template>

            <!-- Modo 2: Agregar ítems a una observación existente -->
            <template v-else>
              <div
                class="info-banner-box pa-3 mb-4 rounded-lg d-flex align-center"
              >
                <v-icon color="info" small class="mr-2"
                  >mdi-information-outline</v-icon
                >
                <span class="caption grey--text text--darken-3">
                  Ingresa los nombres de los ítems que deseas agregar a la lista
                  desplegable.
                </span>
              </div>

              <div class="border-card pa-4 rounded-lg">
                <div class="d-flex align-center justify-space-between mb-2">
                  <label
                    class="text-caption font-weight-bold grey--text text--darken-2"
                  >
                    NUEVOS ÍTEMS A AGREGAR
                  </label>
                  <v-chip
                    v-if="nuevaObsItems.length > 0"
                    x-small
                    color="info"
                    class="font-weight-bold px-2 white--text"
                  >
                    {{ nuevaObsItems.length }} en lista
                  </v-chip>
                </div>

                <div class="d-flex align-center mb-2">
                  <v-text-field
                    v-model="nuevaSubItemInput"
                    placeholder="Ej: BANDA, HOMBRO, SECTOR"
                    outlined
                    dense
                    hide-details
                    autofocus
                    prepend-inner-icon="mdi-playlist-plus"
                    class="flex-grow-1"
                    @keyup.enter="agregarSubItem"
                  ></v-text-field>
                  <v-btn
                    color="primary"
                    depressed
                    small
                    class="ml-2 font-weight-bold text-capitalize px-3"
                    @click="agregarSubItem"
                  >
                    <v-icon small left>mdi-plus</v-icon> Agregar
                  </v-btn>
                </div>

                <div class="caption grey--text text--darken-2 mb-2 px-1">
                  Presiona la tecla
                  <kbd
                    class="px-2 py-0 grey lighten-2 black--text rounded font-weight-bold"
                    >Enter ↵</kbd
                  >
                  o haz clic en <strong>Agregar</strong> para cada ítem.
                </div>

                <!-- Chips agregados -->
                <div
                  v-if="nuevaObsItems.length > 0"
                  class="d-flex flex-wrap mt-2 pt-2 border-top-light"
                >
                  <v-chip
                    v-for="(item, idx) in nuevaObsItems"
                    :key="idx"
                    close
                    small
                    color="info"
                    dark
                    class="ma-1 font-weight-medium elevation-1"
                    @click:close="eliminarSubItem(idx)"
                  >
                    {{ item }}
                  </v-chip>
                </div>
              </div>
            </template>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="px-5 py-3 grey lighten-5">
            <v-spacer></v-spacer>
            <v-btn
              text
              color="grey darken-2"
              class="text-capitalize font-weight-bold px-4"
              @click="dialogNuevaObs = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="primary"
              depressed
              :loading="loadingNuevaObs"
              class="text-capitalize font-weight-bold px-5 rounded-md elevation-2"
              @click="guardarNuevaObs()"
              >Guardar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { axios2 as axios } from "@/interceptor/useApi";
import FileAgent from "../FileAgent.vue";
import global from "../../global";
import MensajeTransicion from "../Alerta.vue";
import Swal from "sweetalert2";

export default {
  props: [
    "dialog",
    "Item",
    "Cliente",
    "Ejes",
    "MotivosInaccesibilidad",
    "TiposValvula",
    "Duales",
  ],
  components: {
    FileAgent,
    MensajeTransicion,
  },
  data() {
    return {
      valid: false,
      habilitareje: true,
      tiposPresion: [
        {
          value: "PSI",
          text: "PSI",
        },
      ],
      accesibilidad: [
        {
          value: "1",
          text: "SI",
        },
        {
          value: "0",
          text: "NO",
        },
      ],
      rulesPresionActual: [
        (v) =>
          (v !== null && v !== undefined && v !== "") ||
          "Presión actual es requerida",
        (v) => Number(v) >= 0 || "Presión no puede ser negativa",
        (v) =>
          Number(v) <= 160 || "Presión actual debe ser menor o igual a 160 PSI",
      ],
      rulesProfundidadExterior: [
        (v) => !!v || "Profundidad izquierda es requerida",
        (v) => v <= 100 || "Profundidad izquierda debe ser menor a 100",
        (v) => {
          const pattern = /^\d{1,3}([\.,]\d{1,2})?$/;
          return pattern.test(v) || "Ingrese un número válido";
        },
      ],
      rulesProfundidadMedia: [
        (v) => {
          const pattern = /^\d{1,3}([\.,]\d{1,2})?$/;
          return pattern.test(v) || "Ingrese un número válido";
        },
        (v) => !!v || "Profundidad media es requerida",
        (v) => v <= 100 || "Profundidad media debe ser menor a 100",
      ],
      rulesCantidadTuercas: [],
      mensajeprofundidadexterior: "",
      mensajeprofundidadinterior: "",
      mensajevalidaciondesgirregular: "",
      mensajevalidacionparareparar: "",
      mensajevalidacionfallasflanco: "",
      mensajevalidacionfallasrodamiento: "",
      mensajeestadoneumatico: "",
      mensajeejedireccional: "",
      validaciondesgirregular: true,
      validacionparareparar: true,
      validacionfallasflanco: true,
      validacionfallasrodamiento: true,
      inhabilitarradio: true,
      inhabilitarseparacion: false,
      ruta: global.ruta_image,
      loading: false,
      mensaje: "",
      color: "success",
      verAlerta: false,
      validarremaext: "last_inspeccion",
      validarremaint: "last_inspeccion",
      ajusteDesgaste: true,
      nuevaFoto1: null,
      previewLocal1: null,
      dialogNuevaObs: false,
      nuevaObsIdentificador: null,
      nuevaObsTitulo: "Agregar Nueva Observación",
      nuevaObsTexto: "",
      nuevaObsTipo: "simple",
      tieneSubItemsCheck: false,
      nuevaObsItems: [],
      nuevaSubItemInput: "",
      loadingNuevaObs: false,
      ObservacionesGenerales: [],
      esAgregarItemASelector: false,
      targetObsRef: null,
      // Mapa reactivo para controlar el estado checked de cada observación { [tipo]: boolean }
      opcionesObs: {},
      // Sistema de notificación superior (reemplaza SweetAlert)
      notification: {
        visible: false,
        type: "warning", // 'error' | 'warning' | 'info'
        title: "",
        message: "",
        actionLabel: null,
        actionFn: null,
      },
      _notifTimer: null,
      // Validación asíncrona de remanente — flags y abort controllers por campo
      _validatingExt: false,
      _validatingInt: false,
      _abortExt: null,
      _abortInt: null,
      _debounceExtTimer: null,
      _debounceIntTimer: null,
      // Valor máximo permitido (remanente original del neumático) por campo
      // Se obtiene del API aunque el switch esté desactivado
      remOriginalExt: null,
      remOriginalInt: null,
    };
  },
  created() {
    if (!this.EstadosTuerca || this.EstadosTuerca.length === 0) {
      this.cargarDatosAdicionales();
    }
    this.inicializarOpcionesObs();
    if (this.Item && this.Item.verificar_rodado != null) {
      // verificar_rodado: 1 = activo (omitir verificación), 0 = desactivado
      this.ajusteDesgaste = !!this.Item.verificar_rodado;
    } else {
      this.ajusteDesgaste = true; // nuevo formulario: activo por defecto
    }
  },
  computed: {
    ...mapState("navigation", ["Permisos"]),
    ...mapState("inspeccion", ["Observaciones", "EstadosTuerca"]),
    puedeAgregar() {
      if (!this.Permisos || !this.$route || !this.$route.meta) return false;
      return global._autorizacion_usuario(this.Permisos, this.$route.meta.id, [
        "2",
      ]);
    },
    // Items de selector para un identificador concreto, tomados de los grupos del store
    itemsDeGrupo() {
      return (tipo) => {
        if (!Array.isArray(this.Observaciones)) return [];
        const grupo = this.Observaciones.find((g) => g.tipo === tipo);
        if (!grupo || !Array.isArray(grupo.items)) return [];
        return grupo.items.map((item) => ({
          value: item.numero != null ? item.numero : item.id,
          text: item.dato || item.nombre,
        }));
      };
    },
    // Lista dinámica de todas las observaciones basada en los grupos del backend
    ListaTodasObservaciones() {
      if (!Array.isArray(this.Observaciones)) return [];

      // Mapeo de identificadores con sub-selects y sus vModelKey conocidos
      const conItemsMap = {
        DI: { multiple: true, vModelKey: "array_desgirregular" },
        PR: { multiple: false, vModelKey: "parareparar" },
        FF: { multiple: false, vModelKey: "fallasflanco" },
        FR: { multiple: false, vModelKey: "fallasrodamiento" },
      };

      return this.Observaciones.map((grupo, idx) => {
        const config = conItemsMap[grupo.tipo] || null;
        const tieneItems = Array.isArray(grupo.items) && grupo.items.length > 0;
        return {
          key: grupo.tipo,
          identificador: grupo.tipo,
          label: grupo.nombre || grupo.tipo,
          opcionIndex: idx,
          tipo: config || tieneItems ? "con_items" : "simple",
          multiple: config ? config.multiple : false,
          items: this.itemsDeGrupo(grupo.tipo),
          vModelKey: config
            ? config.vModelKey
            : tieneItems
            ? "obs_" + grupo.tipo.toLowerCase()
            : null,
          mensajeError:
            this[
              "mensajevalidacion" +
                (config ? config.vModelKey : grupo.tipo.toLowerCase())
            ] ||
            this["mensajevalidacion" + grupo.tipo.toLowerCase()] ||
            "",
          isCustom: !config,
        };
      });
    },
    // Campo de estado de tuercas (TE) tomado del state EstadosTuerca cargado de inspecciones/list
    listEstadosTuerca() {
      return this.EstadosTuerca || [];
    },
    rulesProfundidadIzquierda() {
      return [
        (v) =>
          (v !== null && v !== undefined && v !== "") ||
          "Profundidad izq. es requerida",
        (v) => Number(v) >= 0 || "Debe ser mayor o igual a 0",
        (v) => Number(v) <= 125 || "Debe ser menor a 125",
        (v) => {
          const pattern = /^\d{1,3}([\.,]\d{1,2})?$/;
          return pattern.test(v) || "Máx 3 enteros y 2 decimales";
        },
        (v) => {
          // Switch ACTIVADO: validación completa contra rodado anterior
          if (this.ajusteDesgaste) {
            if (this.mensajeprofundidadexterior) {
              return this.mensajeprofundidadexterior;
            }
            if (this.validarremaext === "remanente_original") {
              return "Supera el remanente original";
            }
            return true;
          }
          // Switch DESACTIVADO: sólo validar que no supere el máximo original
          if (this.remOriginalExt !== null && v !== null && v !== "") {
            return (
              Number(v) <= Number(this.remOriginalExt) ||
              `No puede superar el remanente original (${this.remOriginalExt} mm)`
            );
          }
          return true;
        },
      ];
    },
    rulesProfundidadDerecha() {
      return [
        (v) =>
          (v !== null && v !== undefined && v !== "") ||
          "Profundidad der. es requerida",
        (v) => Number(v) >= 0 || "Debe ser mayor o igual a 0",
        (v) => Number(v) <= 125 || "Debe ser menor a 125",
        (v) => {
          const pattern = /^\d{1,3}([\.,]\d{1,2})?$/;
          return pattern.test(v) || "Máx 3 enteros y 2 decimales";
        },
        (v) => {
          // Switch ACTIVADO: validación completa contra rodado anterior
          if (this.ajusteDesgaste) {
            if (this.mensajeprofundidadinterior) {
              return this.mensajeprofundidadinterior;
            }
            if (this.validarremaint === "remanente_original") {
              return "Supera el remanente original";
            }
            return true;
          }
          // Switch DESACTIVADO: sólo validar que no supere el máximo original
          if (this.remOriginalInt !== null && v !== null && v !== "") {
            return (
              Number(v) <= Number(this.remOriginalInt) ||
              `No puede superar el remanente original (${this.remOriginalInt} mm)`
            );
          }
          return true;
        },
      ];
    },
    rulesCantidadTuercasComputed() {
      if (this.Item && this.Item.tuercaestado && this.Item.tuercaestado != 1) {
        return [
          (v) =>
            (v !== null && v !== undefined && v !== "") ||
            "Cantidad de tuercas es requerida",
          (v) => Number(v) > 0 || "Cantidad debe ser mayor a 0",
        ];
      }
      return [];
    },
  },
  watch: {
    dialog: {
      immediate: true,
      handler(val) {
        if (val) {
          // Restaurar estado del switch desde el campo persistido en backend
          this.ajusteDesgaste =
            this.Item && this.Item.verificar_rodado != null
              ? !!this.Item.verificar_rodado
              : true;
          this.mensajeprofundidadexterior = "";
          this.mensajeprofundidadinterior = "";
          this.validarremaext = "last_inspeccion";
          this.validarremaint = "last_inspeccion";
          this.$nextTick(() => {
            this.inicializarOpcionesObs();
            if (
              this.$refs.form &&
              typeof this.$refs.form.resetValidation === "function"
            ) {
              this.$refs.form.resetValidation();
            }
          });
        } else {
          this.limpiarArchivosLocales();
        }
      },
    },
    "Item.id": {
      handler() {
        this.$nextTick(() => {
          this.inicializarOpcionesObs();
        });
      },
    },
    "Item.num_serie": {
      handler() {
        this.$nextTick(() => {
          this.inicializarOpcionesObs();
        });
      },
    },
  },
  methods: {
    ...mapActions("inspeccion", [
      "validarRemanente",
      "cargarDatosAdicionales",
      "recargarObservaciones",
      "guardarObservacion",
    ]),

    inicializarOpcionesObs() {
      if (!this.Item) return;

      // 1. Convertir desgirregular a array_desgirregular si viene como string
      if (
        this.Item.desgirregular != null &&
        this.Item.desgirregular !== "" &&
        this.Item.desgirregular != 0
      ) {
        if (
          !Array.isArray(this.Item.array_desgirregular) ||
          this.Item.array_desgirregular.length === 0
        ) {
          const rawArr =
            typeof this.Item.desgirregular === "string"
              ? this.Item.desgirregular.split(",")
              : Array.isArray(this.Item.desgirregular)
              ? this.Item.desgirregular
              : [this.Item.desgirregular];
          const mappedArr = rawArr.map((v) => {
            const n = parseInt(v);
            return !isNaN(n) ? n : v;
          });
          this.$set(this.Item, "array_desgirregular", mappedArr);
        }
      }

      // 2. Formatear parareparar, fallasflanco y fallasrodamiento a entero si vienen como string
      if (
        this.Item.parareparar != null &&
        this.Item.parareparar !== "" &&
        this.Item.parareparar != 0 &&
        this.Item.parareparar !== "Sin observación"
      ) {
        const n = parseInt(this.Item.parareparar);
        if (!isNaN(n)) this.Item.parareparar = n;
      }
      if (
        this.Item.fallasflanco != null &&
        this.Item.fallasflanco !== "" &&
        this.Item.fallasflanco != 0 &&
        this.Item.fallasflanco !== "Sin observación"
      ) {
        const n = parseInt(this.Item.fallasflanco);
        if (!isNaN(n)) this.Item.fallasflanco = n;
      }
      if (
        this.Item.fallasrodamiento != null &&
        this.Item.fallasrodamiento !== "" &&
        this.Item.fallasrodamiento != 0 &&
        this.Item.fallasrodamiento !== "Sin observación"
      ) {
        const n = parseInt(this.Item.fallasrodamiento);
        if (!isNaN(n)) this.Item.fallasrodamiento = n;
      }

      // 3. String otros
      const otrosStr = (this.Item.otros || "").toString().toUpperCase();
      const otrosPartes = otrosStr.split(",").map((s) => s.trim());

      // 4. Evaluar cada observacion en ListaTodasObservaciones
      if (Array.isArray(this.ListaTodasObservaciones)) {
        this.ListaTodasObservaciones.forEach((obs) => {
          let activo = false;
          const idUpper = (obs.identificador || "").toUpperCase();
          const labelUpper = (obs.label || "").toUpperCase();

          // A. Por vModelKey en Item
          if (
            obs.vModelKey &&
            this.Item[obs.vModelKey] != null &&
            this.Item[obs.vModelKey] !== "" &&
            this.Item[obs.vModelKey] != 0
          ) {
            if (Array.isArray(this.Item[obs.vModelKey])) {
              if (this.Item[obs.vModelKey].length > 0) activo = true;
            } else {
              activo = true;
            }
          }

          // B. Por campos específicos de la base de datos
          if (
            idUpper === "DI" &&
            (this.Item.desgirregular ||
              (Array.isArray(this.Item.array_desgirregular) &&
                this.Item.array_desgirregular.length > 0))
          ) {
            activo = true;
          }
          if (
            idUpper === "PR" &&
            this.Item.parareparar != null &&
            this.Item.parareparar !== "" &&
            this.Item.parareparar != 0 &&
            this.Item.parareparar !== "Sin observación"
          ) {
            activo = true;
          }
          if (
            idUpper === "FF" &&
            this.Item.fallasflanco != null &&
            this.Item.fallasflanco !== "" &&
            this.Item.fallasflanco != 0 &&
            this.Item.fallasflanco !== "Sin observación"
          ) {
            activo = true;
          }
          if (
            idUpper === "FR" &&
            this.Item.fallasrodamiento != null &&
            this.Item.fallasrodamiento !== "" &&
            this.Item.fallasrodamiento != 0 &&
            this.Item.fallasrodamiento !== "Sin observación"
          ) {
            activo = true;
          }
          if (
            idUpper === "AD" &&
            (this.Item.arodefectuoso || this.Item.d_arodefectuoso === "SI")
          ) {
            activo = true;
          }

          // C. Por string otros
          if (otrosStr) {
            otrosPartes.forEach((parte) => {
              if (
                parte === labelUpper ||
                parte === idUpper ||
                parte.startsWith(labelUpper + ":") ||
                parte.startsWith(idUpper + ":")
              ) {
                activo = true;

                // Extraer sub-item si no tenía asignado vModelKey
                if (
                  obs.tipo === "con_items" &&
                  obs.vModelKey &&
                  (this.Item[obs.vModelKey] == null ||
                    this.Item[obs.vModelKey] === "")
                ) {
                  const colonIdx = parte.indexOf(":");
                  if (colonIdx !== -1) {
                    const subText = parte.substring(colonIdx + 1).trim();
                    if (Array.isArray(obs.items) && obs.items.length > 0) {
                      const found = obs.items.find(
                        (i) => (i.text || "").toUpperCase() === subText,
                      );
                      if (found) {
                        if (obs.multiple) {
                          this.$set(this.Item, obs.vModelKey, [found.value]);
                        } else {
                          this.$set(this.Item, obs.vModelKey, found.value);
                        }
                      }
                    }
                  }
                }
              }
            });
          }

          this.$set(this.opcionesObs, obs.identificador, activo);
        });
      }
    },

    limpiarArchivosLocales() {
      if (this.previewLocal1) URL.revokeObjectURL(this.previewLocal1);
      this.nuevaFoto1 = null;
      this.previewLocal1 = null;
      if (
        this.$refs.fileAgent &&
        typeof this.$refs.fileAgent.reset === "function"
      ) {
        this.$refs.fileAgent.reset();
      }
    },

    async subirFoto(file) {
      const formData = new FormData();
      formData.append("file", file);
      const res = await axios.post("imagen/subirimagen", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return typeof res.data === "string"
        ? res.data
        : res.data?.data || res.data?.nombre || "";
    },

    archivosubido: function ({ valor, fileRecords }) {
      this.nuevaFoto1 =
        fileRecords && fileRecords.length > 0 ? fileRecords : null;
      if (this.previewLocal1) URL.revokeObjectURL(this.previewLocal1);
      if (this.nuevaFoto1 && this.nuevaFoto1[0] && this.nuevaFoto1[0].file) {
        this.previewLocal1 = URL.createObjectURL(this.nuevaFoto1[0].file);
      } else {
        this.previewLocal1 = null;
      }
    },

    onEjes: function () {
      if (this.Item.id_ejes == 1) {
        this.Duales[4].opcion = true;
        this.onDualesMalHermanados2();
        this.inhabilitarradio = true;
        this.inhabilitarseparacion = true;
      } else {
        this.inhabilitarradio = false;
        this.inhabilitarseparacion = false;
      }
    },

    onAccesibilidad: function () {
      if (this.Item.accesibilidad == 1) {
        this.Item.motivo_inaccesibilidad = null;
        if (this.Item.presion == 0) {
          this.Item.presion = null;
        }
      } else {
        this.Item.presion = 0;
      }
    },

    onObservaciones: function () {
      // Limpiar valores del Item cuando se desmarca una observación con sub-items
      if (Array.isArray(this.ListaTodasObservaciones)) {
        this.ListaTodasObservaciones.forEach((o) => {
          if (!o.vModelKey) return;
          const activo = !!this.opcionesObs[o.identificador];
          if (!activo) {
            this.Item[o.vModelKey] = o.multiple ? [] : null;
          }
        });
      }
      this.validacionObservaciones();
    },

    onDualesMalHermanados1: function () {
      // Al marcar cualquier opción 0-3, desmarcar "No aplica"
      if (Array.isArray(this.Duales) && this.Duales[4]) {
        this.Duales[4].opcion = false;
      }
    },

    onDualesMalHermanados2: function () {
      // Al marcar "No aplica", desmarcar opciones 0-3
      if (
        Array.isArray(this.Duales) &&
        this.Duales[4] &&
        this.Duales[4].opcion == true
      ) {
        if (this.Duales[0]) this.Duales[0].opcion = false;
        if (this.Duales[1]) this.Duales[1].opcion = false;
        if (this.Duales[2]) this.Duales[2].opcion = false;
        if (this.Duales[3]) this.Duales[3].opcion = false;
      }
    },

    /**
     * Recalcula el NSD mínimo y actualiza el mensaje de estado del neumático.
     * No lanza llamadas al API.
     */
    _recalcularMinimo() {
      if (!this.Item) return;
      const minimo = Math.min(
        this.Item.exterior != null && this.Item.exterior !== ""
          ? Number(this.Item.exterior)
          : 1000,
        this.Item.interior != null && this.Item.interior !== ""
          ? Number(this.Item.interior)
          : 1000,
      );
      if (this.Item.rem_proximo && minimo <= Number(this.Item.rem_proximo)) {
        this.mensajeestadoneumatico =
          "Elige la opción correcta para NSD = " + minimo.toFixed(1) + " mm";
      } else {
        this.mensajeestadoneumatico = "";
      }
    },

    /**
     * Valida el remanente de UN campo contra el backend.
     * - Cancela la petición anterior del mismo campo si todavía está en vuelo.
     * - Actualiza los flags _validatingExt/_validatingInt para que agregar()
     *   pueda esperar a que ambas validaciones terminen antes de guardar.
     *
     * @param {'exterior'|'interior'} descripcion
     */
    onValidarRemanente: async function (descripcion) {
      if (!this.Item) return;

      // Recalcular NSD sin necesidad de llamar al API
      this._recalcularMinimo();

      // Solo actuar para 'exterior' o 'interior'
      if (!descripcion || descripcion === "") return;

      const valActual = this.Item[descripcion];
      const esInvalido =
        valActual === null ||
        valActual === undefined ||
        valActual === "" ||
        isNaN(Number(valActual));

      if (esInvalido) {
        if (descripcion === "exterior") {
          this.mensajeprofundidadexterior = "";
          this.validarremaext = "last_inspeccion";
        } else {
          this.mensajeprofundidadinterior = "";
          this.validarremaint = "last_inspeccion";
        }
        return;
      }

      // --- Cancelar petición anterior del mismo campo ---
      const abortKey = descripcion === "exterior" ? "_abortExt" : "_abortInt";
      const validFlag =
        descripcion === "exterior" ? "_validatingExt" : "_validatingInt";

      if (this[abortKey]) {
        this[abortKey].abort();
      }
      const controller = new AbortController();
      this[abortKey] = controller;
      this[validFlag] = true;

      try {
        this.Item.descripcion_remanente_validado = descripcion;

        // Llamada al store, pasando el signal para cancelación
        const validacion = await this.validarRemanente({
          item: this.Item,
          signal: controller.signal,
        });

        // Si fue abortada, ignorar resultado
        if (controller.signal.aborted) return;

        // Extraer siempre remanente_original del resultado (disponible en ambos modos)
        const remOriginal =
          validacion && typeof validacion === "object"
            ? validacion.remanente_original ?? null
            : null;

        if (descripcion === "exterior") {
          this.remOriginalExt = remOriginal;
        } else {
          this.remOriginalInt = remOriginal;
        }

        // ── Switch DESACTIVADO: solo validar contra el máximo original ──────
        if (!this.ajusteDesgaste) {
          // Las rules en computed ya leen remOriginalExt/remOriginalInt;
          // limpiar mensajes de rodado para no bloquear el guardado
          if (descripcion === "exterior") {
            this.mensajeprofundidadexterior = "";
            this.validarremaext = "last_inspeccion";
          } else {
            this.mensajeprofundidadinterior = "";
            this.validarremaint = "last_inspeccion";
          }
          this.$nextTick(() => {
            if (this.$refs.form) this.$refs.form.validate();
          });
          return;
        }

        // ── Switch ACTIVADO: validación completa contra rodado anterior ──────
        let mensaje = "";
        let remanente = "";

        if (typeof validacion === "string") {
          mensaje = validacion;
          remanente = "error";
        } else if (validacion && typeof validacion === "object") {
          mensaje = validacion.message || "";
          remanente = validacion.remanente || "";
        }

        if (descripcion === "exterior") {
          if (mensaje && mensaje !== "Correcto") {
            this.mensajeprofundidadexterior = mensaje;
            this.validarremaext = remanente || "error";
          } else {
            this.mensajeprofundidadexterior = "";
            this.validarremaext = remanente || "last_inspeccion";
          }
        } else {
          if (mensaje && mensaje !== "Correcto") {
            this.mensajeprofundidadinterior = mensaje;
            this.validarremaint = remanente || "error";
          } else {
            this.mensajeprofundidadinterior = "";
            this.validarremaint = remanente || "last_inspeccion";
          }
        }

        this.$nextTick(() => {
          if (this.$refs.form) this.$refs.form.validate();
        });
      } catch (err) {
        if (err && err.name === "AbortError") return; // petición cancelada, ignorar
        console.error("[onValidarRemanente] error inesperado:", err);
      } finally {
        // Sólo limpiar el flag si esta instancia del controller sigue siendo la activa
        if (this[abortKey] === controller) {
          this[abortKey] = null;
          this[validFlag] = false;
        }
      }
    },

    /**
     * Wrapper con debounce para @input en campo exterior.
     * Espera 400 ms sin escritura antes de llamar al API.
     */
    onInputExteriorDebounced() {
      if (this._debounceExtTimer) clearTimeout(this._debounceExtTimer);
      this._debounceExtTimer = setTimeout(() => {
        this.onValidarRemanente("exterior");
      }, 400);
    },

    /**
     * Wrapper con debounce para @input en campo interior.
     */
    onInputInteriorDebounced() {
      if (this._debounceIntTimer) clearTimeout(this._debounceIntTimer);
      this._debounceIntTimer = setTimeout(() => {
        this.onValidarRemanente("interior");
      }, 400);
    },

    onCambioAjusteDesgaste: async function (val) {
      if (this.Item) {
        // Escribir en el campo que el backend persiste (verificar_rodado)
        this.$set(this.Item, "verificar_rodado", val ? 1 : 0);
      }
      if (val) {
        // Lanzar ambas validaciones en paralelo cuando se activa el ajuste
        const promesas = [];
        if (
          this.Item &&
          this.Item.exterior !== null &&
          this.Item.exterior !== undefined &&
          this.Item.exterior !== ""
        ) {
          promesas.push(this.onValidarRemanente("exterior"));
        }
        if (
          this.Item &&
          this.Item.interior !== null &&
          this.Item.interior !== undefined &&
          this.Item.interior !== ""
        ) {
          promesas.push(this.onValidarRemanente("interior"));
        }
        await Promise.all(promesas);
      } else {
        this.mensajeprofundidadexterior = "";
        this.mensajeprofundidadinterior = "";
        this.validarremaext = "last_inspeccion";
        this.validarremaint = "last_inspeccion";
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.validate();
        }
      });
    },

    onInputExterior: function () {
      // Limpiar mensaje inmediatamente (feedback visual rápido) y
      // cancelar cualquier debounce anterior antes de iniciar uno nuevo
      this.mensajeprofundidadexterior = "";
      this.validarremaext = "last_inspeccion";
      this.remOriginalExt = null; // limpiar máximo; se actualiza al llamar al API
      this.onLimitarDecimales("exterior");
      this.onInputExteriorDebounced();
    },

    onInputInterior: function () {
      this.mensajeprofundidadinterior = "";
      this.validarremaint = "last_inspeccion";
      this.remOriginalInt = null; // limpiar máximo; se actualiza al llamar al API
      this.onLimitarDecimales("interior");
      this.onInputInteriorDebounced();
    },

    onLimitarDecimales: function (campo) {
      if (
        this.Item[campo] === null ||
        this.Item[campo] === undefined ||
        this.Item[campo] === ""
      ) {
        return;
      }
      let val = String(this.Item[campo]);
      val = val.replace(",", ".");
      const partes = val.split(".");
      let enteros = partes[0];
      let decimales = partes[1];

      if (enteros && enteros.length > 3) {
        enteros = enteros.slice(0, 3);
      }
      if (decimales !== undefined && decimales.length > 2) {
        decimales = decimales.slice(0, 2);
      }

      const nuevoValor =
        decimales !== undefined ? `${enteros}.${decimales}` : enteros;
      if (val !== nuevoValor) {
        this.$nextTick(() => {
          this.Item[campo] = nuevoValor;
        });
      }
    },

    onEstadoTuerca: function () {
      if (this.Item.tuercaestado == 1) {
        this.Item.tuercacantidad = null;
        this.rulesCantidadTuercas = [];
      } else {
        this.rulesCantidadTuercas = [
          (v) => !!v || "Cantidad de tuercas es requerido",
        ];
      }
    },

    cerrarDialogo: function (valor = false) {
      this.limpiarArchivosLocales();
      // NO resetear ajusteDesgaste aquí: se restaura desde Item.verificar_rodado
      // en el watch:dialog handler cuando el diálogo vuelva a abrirse.
      this.mensajeprofundidadexterior = "";
      this.mensajeprofundidadinterior = "";
      this.validarremaext = "last_inspeccion";
      this.validarremaint = "last_inspeccion";
      if (
        this.$refs.form &&
        typeof this.$refs.form.resetValidation === "function"
      ) {
        try {
          this.$refs.form.resetValidation();
        } catch (e) {
          // Ignorar si el formulario ya se desmontó
        }
      }
      this.$emit("cerrarModal", valor);
    },

    asignarValores: function () {
      this.Item.resultado = "";
      let resultado = "";
      let desgirregular = "";
      //let parareparar = "";
      let otros = "";

      if (Array.isArray(this.Duales)) {
        this.Duales.forEach((element) => {
          if (element.opcion == true) {
            resultado += element.text + ",";
          }
        });
      }

      // Construir string 'otros' desde opcionesObs (checkboxes activos)
      if (Array.isArray(this.ListaTodasObservaciones)) {
        this.ListaTodasObservaciones.forEach((obs) => {
          if (this.opcionesObs && this.opcionesObs[obs.identificador]) {
            const idUpper = (obs.identificador || "").toUpperCase();
            // Omitir columnas con campos físicos dedicados en la tabla DB (DI, PR, FF)
            // if (idUpper === 'DI' || idUpper === 'PR' || idUpper === 'FF') {
            //     return;
            // }

            otros += obs.label + ",";
          }
        });
      }

      if (Array.isArray(this.Item.array_desgirregular)) {
        this.Item.array_desgirregular.forEach((element) => {
          desgirregular += element + ",";
        });
      }

      if (
        this.Item.estado == "Continuar en Operación" ||
        this.Item.estado == "Lista para Reencauchar"
      ) {
        this.Item.ruta = [];
        this.Item.neumaticoimg1 = null;
        this.Item.neumaticoimgruta1 = null;
      }

      //valores
      this.Item.resultado = resultado.substring(0, resultado.length - 1);
      this.Item.desgirregular =
        desgirregular != ""
          ? desgirregular.substring(0, desgirregular.length - 1)
          : null;
      //this.Item.parareparar = parareparar != "" ? parareparar.substring(0, parareparar.length - 1) : null;
      //this.Item.fallasflanco = fallasflanco != "" ? fallasflanco.substring(0, fallasflanco.length - 1) : null;
      this.Item.otros = otros != "" ? otros.substring(0, otros.length - 1) : "";
    },

    validacionObservaciones: function () {
      this.mensajevalidaciondesgirregular = "";
      this.mensajevalidacionparareparar = "";
      this.mensajevalidacionfallasflanco = "";
      this.mensajevalidacionfallasrodamiento = "";
      this.validaciondesgirregular = true;
      this.validacionparareparar = true;
      this.validacionfallasflanco = true;
      this.validacionfallasrodamiento = true;

      if (Array.isArray(this.ListaTodasObservaciones)) {
        this.ListaTodasObservaciones.forEach((o) => {
          if (!o.vModelKey || o.tipo !== "con_items") return;
          if (!this.opcionesObs || !this.opcionesObs[o.identificador]) return;

          const val = this.Item[o.vModelKey];
          const sinSeleccion = o.multiple
            ? !Array.isArray(val) || val.length === 0
            : val == null;

          if (sinSeleccion) {
            const msgKey =
              "mensajevalidacion" +
              (o.vModelKey || o.identificador.toLowerCase());
            const validKey =
              "validacion" + (o.vModelKey || o.identificador.toLowerCase());
            const msgKeyId =
              "mensajevalidacion" + o.identificador.toLowerCase();
            const validKeyId = "validacion" + o.identificador.toLowerCase();
            if (msgKey in this) this[msgKey] = `Seleccione ${o.label}`;
            else if (msgKeyId in this) this[msgKeyId] = `Seleccione ${o.label}`;
            if (validKey in this) this[validKey] = false;
            else if (validKeyId in this) this[validKeyId] = false;
          }
        });
      }
    },

    obtenerInputsFaltantes: function () {
      const faltantes = [];

      // 1. Posición *
      if (!this.Item.posicion && !this.Item.d_posicion) {
        faltantes.push("Posición");
      }

      // 2. Nro. Serie del Neumático *
      if (!this.Item.num_serie || !String(this.Item.num_serie).trim()) {
        faltantes.push("Nro. Serie del Neumático");
      }

      // 3. Eje *
      if (!this.Item.id_ejes) {
        faltantes.push("Seleccionar Eje");
      }

      // 4. Tipo de presión *
      if (!this.Item.tipo_presion) {
        faltantes.push("Tipo de presión");
      }

      // 5. Accesibilidad *
      if (
        this.Item.accesibilidad === null ||
        this.Item.accesibilidad === undefined ||
        this.Item.accesibilidad === ""
      ) {
        faltantes.push("Accesibilidad");
      }

      // 6. Presión actual * (requerido si accesibilidad != 0)
      if (this.Item.accesibilidad != 0) {
        if (
          this.Item.presion === null ||
          this.Item.presion === undefined ||
          this.Item.presion === "" ||
          isNaN(Number(this.Item.presion))
        ) {
          faltantes.push("Presión actual");
        } else if (
          Number(this.Item.presion) < 0 ||
          Number(this.Item.presion) > 160
        ) {
          faltantes.push("Presión actual (debe ser entre 0 y 160 PSI)");
        }
      }

      // 7. Válvula *
      if (!this.Item.valvula) {
        faltantes.push("Válvula");
      }

      // 8. Motivo de inaccesibilidad * (requerido si accesibilidad == '0' o 0)
      if (
        (this.Item.accesibilidad == "0" || this.Item.accesibilidad === 0) &&
        !this.Item.motivo_inaccesibilidad
      ) {
        faltantes.push("Motivo de inaccesibilidad");
      }

      // 9. Profundidad Izquierda *
      if (
        this.Item.exterior === null ||
        this.Item.exterior === undefined ||
        this.Item.exterior === "" ||
        isNaN(Number(this.Item.exterior))
      ) {
        faltantes.push("Profundidad Izquierda (*)");
      } else {
        const ext = Number(this.Item.exterior);
        if (ext < 0 || ext > 125) {
          faltantes.push("Profundidad Izquierda (debe ser entre 0 y 125 mm)");
        }
      }

      // 10. Profundidad Derecha *
      if (
        this.Item.interior === null ||
        this.Item.interior === undefined ||
        this.Item.interior === "" ||
        isNaN(Number(this.Item.interior))
      ) {
        faltantes.push("Profundidad Derecha (*)");
      } else {
        const int = Number(this.Item.interior);
        if (int < 0 || int > 125) {
          faltantes.push("Profundidad Derecha (debe ser entre 0 y 125 mm)");
        }
      }

      // 11. Estado de tuerca *
      if (!this.Item.tuercaestado) {
        faltantes.push("Estado de tuerca");
      }

      // 12. Cantidad de tuercas (si tuercaestado != 1)
      if (
        this.Item.tuercaestado &&
        this.Item.tuercaestado != 1 &&
        (this.Item.tuercacantidad === null ||
          this.Item.tuercacantidad === undefined ||
          this.Item.tuercacantidad === "" ||
          Number(this.Item.tuercacantidad) <= 0)
      ) {
        faltantes.push("Cantidad de tuercas");
      }

      // 13. Recomendación *
      if (!this.Item.recomendacion || !String(this.Item.recomendacion).trim()) {
        faltantes.push("Recomendación");
      }

      // 14. Estado del neumático *
      if (!this.Item.estado) {
        faltantes.push("Estado del Neumático");
      }

      // 15. Observaciones seleccionadas con opciones pendientes
      if (Array.isArray(this.ListaTodasObservaciones)) {
        this.ListaTodasObservaciones.forEach((o) => {
          if (
            o.tipo === "con_items" &&
            o.vModelKey &&
            this.opcionesObs &&
            this.opcionesObs[o.identificador]
          ) {
            const val = this.Item[o.vModelKey];
            const vacio = o.multiple
              ? !Array.isArray(val) || val.length === 0
              : val == null || val === "";
            if (vacio) {
              faltantes.push(`Observación: ${o.label} (seleccione una opción)`);
            }
          }
        });
      }

      return faltantes;
    },

    agregar: async function () {
      if (this.loading) return;

      this.loading = true;

      this.asignarValores();
      this.validacionObservaciones();

      // 1. Si Ajuste de Desgaste está activado, esperar validaciones en vuelo
      //    y si no hay ninguna en curso, forzar una validación fresca en paralelo.
      if (this.ajusteDesgaste) {
        const promesas = [];
        if (
          this.Item.exterior !== null &&
          this.Item.exterior !== undefined &&
          this.Item.exterior !== ""
        ) {
          promesas.push(this.onValidarRemanente("exterior"));
        }
        if (
          this.Item.interior !== null &&
          this.Item.interior !== undefined &&
          this.Item.interior !== ""
        ) {
          promesas.push(this.onValidarRemanente("interior"));
        }
        if (promesas.length > 0) await Promise.all(promesas);
      }

      // 2. Disparar validación visual en el formulario de Vuetify
      const isFormValid = this.$refs.form ? this.$refs.form.validate() : true;

      // 3. Validar si el Ajuste de Desgaste está activado y genera alertas/mensajes de remanente
      if (this.ajusteDesgaste) {
        const erroresRemanente = [];
        if (this.mensajeprofundidadexterior) {
          erroresRemanente.push(
            `Izquierdo: ${this.mensajeprofundidadexterior}`,
          );
        }
        if (this.mensajeprofundidadinterior) {
          erroresRemanente.push(`Derecho: ${this.mensajeprofundidadinterior}`);
        }
        if (
          this.validarremaext === "remanente_original" &&
          !this.mensajeprofundidadexterior
        ) {
          erroresRemanente.push("Izquierdo: Supera el remanente original");
        }
        if (
          this.validarremaint === "remanente_original" &&
          !this.mensajeprofundidadinterior
        ) {
          erroresRemanente.push("Derecho: Supera el remanente original");
        }

        if (erroresRemanente.length > 0) {
          const listaHtml = erroresRemanente
            .map((e) => `<span class="insp-notif-item">• ${e}</span>`)
            .join("");
          this.showNotification(
            "error",
            "Alerta en Niveles de Remanente",
            `El <strong>Ajuste de Desgaste</strong> está activado. Corrija o desactívelo para continuar:<br>${listaHtml}`,
          );
          this.loading = false;
          return;
        }
      }

      // 4. Obtener inputs que faltan completar (todos los inputs con asterisco y obligatorios)
      const faltantes = this.obtenerInputsFaltantes();
      if (faltantes.length > 0 || !isFormValid) {
        const listaAMostrar =
          faltantes.length > 0
            ? faltantes
            : ["Verifique los campos marcados en rojo en el formulario."];
        const listaHtml = listaAMostrar
          .map((f) => `<span class="insp-notif-item">• ${f}</span>`)
          .join("");
        this.showNotification(
          "warning",
          "Campos obligatorios incompletos",
          `Faltan completar o corregir los campos marcados con (*):<br>${listaHtml}`,
        );
        this.loading = false;
        return;
      }

      // 5. Validar observaciones pendientes
      if (
        !this.validaciondesgirregular ||
        !this.validacionparareparar ||
        !this.validacionfallasflanco ||
        !this.validacionfallasrodamiento
      ) {
        this.showNotification(
          "warning",
          "Observaciones incompletas",
          "Debe seleccionar las opciones requeridas para todas las observaciones marcadas.",
        );
        this.loading = false;
        return;
      }

      // 6. Validar datos mínimos de vehículo y posición
      if (!this.Item.id_vehiculo || !this.Item.posicion) {
        this.showNotification(
          "warning",
          "Datos incompletos",
          "Falta información del vehículo o posición para registrar la inspección.",
        );
        this.loading = false;
        return;
      }

      // 7. Proceder a guardar
      try {

        // Subir imagen si se seleccionó un archivo nuevo para neumático en mal estado
        if (
          (this.Item.estado == "Lista para Reemplazar" ||
            this.Item.estado == "Neumático en Mal estado") &&
          this.nuevaFoto1 &&
          this.nuevaFoto1.length > 0 &&
          this.nuevaFoto1[0].file
        ) {
          const nombre1 = await this.subirFoto(this.nuevaFoto1[0].file);
          if (nombre1) {
            this.Item.ruta = [{ upload: { data: nombre1 } }];
            this.Item.neumaticoimg1 = nombre1;
            this.Item.neumaticoimgruta1 =
              "images/reportes/img_neumaticos_mal_estado/" + nombre1;
          }
        }

        let url = "";
        if (this.Item.id == null) {
          url = "inspecciones/storeInspeccion";
        } else {
          url = "inspecciones/updateInspeccion";
        }

        const data = {
          id_cliente: localStorage.getItem("idcliente"),
          id_usuario: localStorage.getItem("id"),
          id: this.Item.id,
          id_vehiculo: this.Item.id_vehiculo,
          km_inspeccion_parcial: this.Item.km_inspeccion,
          posicion: this.Item.posicion,
          id_neumaticos: this.Item.id_neumaticos,
          serieneumatico: this.Item.num_serie,
          id_ejes: this.Item.id_ejes,
          tipo_presion: this.Item.tipo_presion,
          presion: this.Item.presion,
          valvula: this.Item.valvula,
          accesibilidad: this.Item.accesibilidad,
          motivo_inaccesibilidad: this.Item.motivo_inaccesibilidad,
          exterior: this.Item.exterior,
          medio: this.Item.medio,
          interior: this.Item.interior,
          resultado: this.Item.resultado,
          separaciond: this.Item.sep_duales,
          otros: this.Item.otros,
          desgirregular: this.Item.desgirregular,
          parareparar: this.Item.parareparar,
          fallasflanco: this.Item.fallasflanco,
          fallasrodamiento: this.Item.fallasrodamiento,
          tuercaestado: this.Item.tuercaestado,
          tuercacantidad: this.Item.tuercacantidad,
          estado: this.Item.estado,
          recomendacion: this.Item.recomendacion,
          // Estado del switch "Omitir verificación de rodado": 1=omitir, 0=verificar
          verificar_rodado: this.ajusteDesgaste ? 1 : 0,
          ruta:
            this.Item.estado == "Continuar en Operación" ||
            this.Item.estado == "Lista para Reencauchar"
              ? null
              : this.Item.ruta == null
              ? this.Item.neumaticoimgruta1
              : this.Item.ruta,
          proyecto: "web",
        };

        let response;
        try {
          response = await axios.post(url, data);
        } catch (error) {
          console.error("Error al registrar inspección parcial:", error);
          const status = error.response ? error.response.status : null;
          const errorData = error.response?.data;
          const errorMsg =
            errorData?.message ||
            errorData?.error ||
            "No se pudo registrar la inspección parcial.";

          if (status === 422) {
            this.showNotification(
              "warning",
              "Conflicto en Neumático / Posición",
              `${errorMsg} Es posible que el neumático haya sido rotado o modificado en paralelo.`,
              {
                label: "Recargar Posiciones",
                fn: () => {
                  this.cerrarDialogo(false);
                  this.$emit("recargarPosicionesVehiculo");
                },
              },
            );
          } else {
            this.showNotification("error", "Error al guardar", errorMsg);
          }
          return;
        } finally {
          this.loading = false;
        }

        // Si llegó aquí, el backend guardó/actualizó exitosamente (HTTP 200)
        try {
          const respData = response.data || {};
          let idEmit = this.Item.id ? parseInt(this.Item.id) : null;

          if (respData.id) {
            idEmit = parseInt(respData.id);
          } else if (respData.resultado && respData.resultado.id) {
            idEmit = parseInt(respData.resultado.id);
          } else if (respData.inspeccion && respData.inspeccion.id) {
            idEmit = parseInt(respData.inspeccion.id);
          } else if (respData.inspeccion_actual) {
            if (typeof respData.inspeccion_actual === "number") {
              idEmit = respData.inspeccion_actual;
            } else if (
              typeof respData.inspeccion_actual === "object" &&
              respData.inspeccion_actual.id
            ) {
              idEmit = parseInt(respData.inspeccion_actual.id);
            } else if (typeof respData.inspeccion_actual === "string") {
              const firstId = respData.inspeccion_actual.split(",")[0].trim();
              const parsed = parseInt(firstId);
              if (!isNaN(parsed)) idEmit = parsed;
            }
          }

          this.limpiarArchivosLocales();
          this.$emit("agregarInspeccionParcial", idEmit);
          this.cerrarDialogo(true);
        } catch (postSaveError) {
          console.warn("Aviso al cerrar diálogo tras guardar:", postSaveError);
          this.cerrarDialogo(true);
        }
      } catch (unexpectedError) {
        console.error("Error inesperado en agregar():", unexpectedError);
      } finally {
        this.loading = false;
      }
    },

    /**
     * Muestra una notificación moderna en la parte superior del diálogo.
     * @param {string} type  - 'error' | 'warning' | 'info'
     * @param {string} title - Título breve
     * @param {string} message - Detalle (puede contener HTML básico)
     * @param {object} [action] - Opcional: { label, fn } para un botón de acción
     */
    showNotification(type, title, message, action = null) {
      if (this._notifTimer) clearTimeout(this._notifTimer);
      this.notification = {
        visible: true,
        type,
        title,
        message,
        actionLabel: action ? action.label : null,
        actionFn: action ? action.fn : null,
      };
      this._notifTimer = setTimeout(() => {
        this.notification.visible = false;
      }, 5000);
    },

    abrirModalNuevaObsGeneral() {
      this.esAgregarItemASelector = false;
      this.targetObsRef = null;
      this.nuevaObsIdentificador = null;
      this.nuevaObsTitulo = "Agregar Nueva Observación";
      this.nuevaObsTexto = "";
      this.nuevaObsTipo = "simple";
      this.tieneSubItemsCheck = false;
      this.nuevaObsItems = [];
      this.nuevaSubItemInput = "";
      this.dialogNuevaObs = true;
    },

    abrirModalNuevaObs(identificador, titulo) {
      this.esAgregarItemASelector = true;
      this.targetObsRef = null;
      this.nuevaObsIdentificador = identificador;
      this.nuevaObsTitulo = "Agregar nuevo ítem a " + titulo;
      this.nuevaObsTexto = titulo;
      this.nuevaObsTipo = "simple";
      this.tieneSubItemsCheck = true;
      this.nuevaObsItems = [];
      this.nuevaSubItemInput = "";
      this.dialogNuevaObs = true;
    },

    abrirModalAgregarSubItemObs(obs) {
      this.esAgregarItemASelector = true;
      this.targetObsRef = obs;
      this.nuevaObsIdentificador = null;
      this.nuevaObsTitulo = "Agregar nuevo ítem a " + obs.text;
      this.nuevaObsTexto = obs.text;
      this.nuevaObsTipo = "simple";
      this.tieneSubItemsCheck = true;
      this.nuevaObsItems = [];
      this.nuevaSubItemInput = "";
      this.dialogNuevaObs = true;
    },

    agregarSubItem() {
      if (this.nuevaSubItemInput && this.nuevaSubItemInput.trim()) {
        const itemText = this.nuevaSubItemInput.trim();
        if (!this.nuevaObsItems.includes(itemText)) {
          this.nuevaObsItems.push(itemText);
        }
        this.nuevaSubItemInput = "";
      }
    },

    eliminarSubItem(index) {
      this.nuevaObsItems.splice(index, 1);
    },

    generarIdentificador(texto) {
      if (!texto || !texto.trim()) return "OB";
      const palabras = texto.trim().split(/\s+/).filter(Boolean);
      if (palabras.length >= 2) {
        return (palabras[0].charAt(0) + palabras[1].charAt(0)).toUpperCase();
      } else if (palabras.length === 1) {
        const palabra = palabras[0];
        return palabra.length >= 2
          ? palabra.substring(0, 2).toUpperCase()
          : (palabra + palabra).toUpperCase();
      }
      return "OB";
    },

    guardarNuevaObs: async function () {
      if (this.nuevaSubItemInput && this.nuevaSubItemInput.trim()) {
        this.agregarSubItem();
      }

      if (this.esAgregarItemASelector) {
        if (
          this.nuevaObsItems.length === 0 &&
          (!this.nuevaObsTexto || !this.nuevaObsTexto.trim())
        )
          return;
      } else {
        if (!this.nuevaObsTexto || !this.nuevaObsTexto.trim()) return;
      }

      try {
        this.loadingNuevaObs = true;
        const tieneItems =
          (this.esAgregarItemASelector && this.nuevaObsItems.length > 0) ||
          (!this.esAgregarItemASelector &&
            this.tieneSubItemsCheck &&
            this.nuevaObsItems.length > 0);
        const tipoFinal = tieneItems ? "con_items" : "simple";

        const identificadorFinal = this.nuevaObsIdentificador || null;
        const codigoFinal =
          identificadorFinal === "TE" || identificadorFinal === "I"
            ? null
            : "OBS";
        const datoFinal =
          this.nuevaObsTexto && this.nuevaObsTexto.trim()
            ? this.nuevaObsTexto.trim()
            : "";

        const data = {
          id_cliente: localStorage.getItem("idcliente"),
          clienteId: localStorage.getItem("idcliente"),
          id_usuario: localStorage.getItem("id"),
          identificador: identificadorFinal,
          codigo: codigoFinal,
          dato: datoFinal,
          items: tieneItems ? this.nuevaObsItems : [],
        };
        const response = await this.guardarObservacion(data);
        const isSuccess =
          response.data &&
          response.data.success &&
          response.data.status !== false;

        if (isSuccess) {
          if (!this.nuevaObsIdentificador) {
            if (this.targetObsRef && Array.isArray(this.targetObsRef.items)) {
              this.targetObsRef.items.push(this.nuevaObsTexto.trim());
            } else if (!this.esAgregarItemASelector) {
              const nuevoItemObj = {
                id: response.data.data ? response.data.data.id : Date.now(),
                identificador: identificadorFinal,
                name: this.nuevaObsTexto.trim(),
                text: this.nuevaObsTexto.trim(),
                opcion: false,
                tipo: tipoFinal,
                items: [...this.nuevaObsItems],
                valSelected: null,
              };
              if (!Array.isArray(this.ObservacionesGenerales)) {
                this.$set(this, "ObservacionesGenerales", []);
              }
              this.ObservacionesGenerales.push(nuevoItemObj);
            }
          } else {
            const nuevoVal = response.data.data
              ? response.data.data.numero || response.data.data.id
              : null;
            const nuevoText = response.data.data
              ? response.data.data.dato || response.data.data.nombre
              : "";
            if (this.nuevaObsIdentificador === "TE") {
              if (nuevoVal && nuevoText) {
                this.$store.commit("inspeccion/AgregarEstadoTuerca", {
                  value: nuevoVal,
                  text: nuevoText,
                });
              }
              this.$set(this.Item, "tuercaestado", nuevoVal);
              if (typeof this.onEstadoTuerca === "function") {
                this.onEstadoTuerca();
              }
            } else if (this.nuevaObsIdentificador === "I") {
              if (nuevoVal && nuevoText) {
                this.$store.commit("inspeccion/AgregarMotivoInaccesibilidad", {
                  value: nuevoVal,
                  text: nuevoText,
                });
              }
              this.$set(this.Item, "motivo_inaccesibilidad", nuevoVal);
            } else if (nuevoVal) {
              const obsObj = this.ListaTodasObservaciones.find(
                (o) => o.identificador === this.nuevaObsIdentificador,
              );
              if (obsObj && obsObj.vModelKey) {
                if (obsObj.multiple) {
                  if (!Array.isArray(this.Item[obsObj.vModelKey])) {
                    this.$set(this.Item, obsObj.vModelKey, []);
                  }
                  this.Item[obsObj.vModelKey].push(nuevoVal);
                } else {
                  this.$set(this.Item, obsObj.vModelKey, nuevoVal);
                }
              }
            }
          }
          this.dialogNuevaObs = false;
          this.mensaje = response.data.message || "Guardado correctamente";
          this.color = "success";
          this.verAlerta = true;
          setTimeout(() => {
            this.verAlerta = false;
          }, 3000);
        }
      } finally {
        this.loadingNuevaObs = false;
      }
    },
  },
  mounted() {
    this.inicializarOpcionesObs();
    if (this.Item && this.Item.id_ejes == 1) {
      this.mensajeejedireccional = "No aplicable para el eje direccional";
      this.inhabilitarradio = true;
      this.inhabilitarseparacion = true;
    } else {
      this.inhabilitarradio = false;
      this.inhabilitarseparacion = false;
      this.mensajeejedireccional = "";
    }
  },
  beforeDestroy() {
    if (this.previewLocal1) {
      URL.revokeObjectURL(this.previewLocal1);
    }
  },
};
</script>

<style scoped>
.letra-14 {
  font-size: 16px;
}

.letra-11 {
  font-size: 11px;
}

.letra-12 {
  font-size: 12px;
}

/* Card panels modernos basados en scrap/nuevo.vue */
.card-panel {
  border: 1px solid #e2e8f0 !important;
  background-color: #ffffff;
  transition: all 0.2s ease;
}

.card-panel:hover {
  border-color: #cbd5e1 !important;
  box-shadow: 0 4px 10px -2px rgba(0, 0, 0, 0.05);
}

.panel-header {
  display: flex;
  align-items: center;
  background-color: #424242;
  color: #ffffff;
  padding: 7px 12px;
  border-radius: 6px;
  margin-bottom: 12px;
}

.panel-header .v-icon {
  color: #ffffff !important;
}

.panel-title {
  font-size: 0.82rem;
  font-weight: 700;
  color: #ffffff;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.bg-actions {
  background-color: #f8fafc;
  border-top: 1px solid #e2e8f0;
}

.border-subcard {
  border: 1px solid #f1f5f9;
  background-color: #f8fafc;
  transition: background-color 0.15s ease;
}

.border-subcard:hover {
  background-color: #f1f5f9;
}

.align-self-start {
  align-self: flex-start !important;
}

.obs-scroll-container {
  max-height: 350px;
  overflow-y: auto;
  padding-right: 4px;
}

.preview-box {
  min-height: 140px;
  background-color: #f8fafc;
  border: 1px dashed #cbd5e1;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
}

.preview-img {
  width: 100%;
  max-height: 180px;
  object-fit: contain;
  background-color: #0f172a;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.modal-header-gradient {
  background: linear-gradient(135deg, #1e88e5 0%, #1565c0 100%);
}

.line-height-1 {
  line-height: 1.2;
}

.close-btn-hover:hover {
  background-color: rgba(255, 255, 255, 0.15);
}

.border-card {
  border: 1px solid #e2e8f0;
  background-color: #ffffff;
}

.bg-light-blue {
  background-color: #f8fafc;
}

.info-banner-box {
  background-color: #e0f2fe;
  border: 1px solid #bae6fd;
}

.dotted-empty-box {
  border: 2px dashed #cbd5e1;
  background-color: #f8fafc;
}

.border-top-light {
  border-top: 1px solid #f1f5f9;
}

.btn-main-header {
  height: 28px !important;
  font-size: 11px !important;
  background-color: #1e88e5 !important;
  border-radius: 4px !important;
  transition: background-color 0.15s ease-in-out !important;
}

.btn-main-header:hover {
  background-color: #1565c0 !important;
}

.btn-item-row {
  border: 1px solid #cbd5e1 !important;
  background-color: #ffffff !important;
  transition: all 0.15s ease-in-out !important;
  width: 22px !important;
  height: 22px !important;
  min-width: 22px !important;
  border-radius: 4px !important;
}

.btn-item-row .v-icon {
  color: #64748b !important;
  font-size: 13px !important;
}

.btn-item-row:hover {
  border-color: #2563eb !important;
  background-color: #eff6ff !important;
}

.btn-item-row:hover .v-icon {
  color: #2563eb !important;
}

/* Toolbar Header Responsive */
.table-header-toolbar {
  min-height: 56px;
}

.table-header-toolbar ::v-deep .v-toolbar__content {
  padding: 8px 14px !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-main-info {
  display: flex;
  align-items: center;
  min-width: 0;
  overflow: hidden;
}

.header-icon-box {
  width: 38px;
  height: 38px;
  min-width: 38px;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-text-block {
  min-width: 0;
  overflow: hidden;
}

.header-company-title {
  font-size: 1.1rem;
  line-height: 1.25;
  letter-spacing: 0.3px;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header-count-chip {
  font-size: 0.85rem !important;
  height: 28px !important;
}

.header-chips-group {
  min-width: 0;
  gap: 8px !important;
}

/* ============================================================
   RESPONSIVE: Mobile (max 600px)
   ============================================================ */
@media (max-width: 600px) {
  .table-header-toolbar {
    min-height: 48px;
  }

  .table-header-toolbar ::v-deep .v-toolbar__content {
    padding: 6px 10px !important;
  }

  .header-icon-box {
    width: 30px;
    height: 30px;
    min-width: 30px;
    border-radius: 6px;
  }

  .header-icon-box .v-icon {
    font-size: 18px !important;
  }

  .header-company-title {
    font-size: 0.85rem !important;
    line-height: 1.2;
  }

  .header-chips-group {
    gap: 6px !important;
  }

  .header-count-chip {
    font-size: 0.7rem !important;
    height: 22px !important;
    padding: 0 5px !important;
  }

  .header-count-chip .v-icon {
    font-size: 12px !important;
    margin-right: 2px !important;
  }

  .form-card-actions {
    flex-direction: column-reverse !important;
    align-items: stretch !important;
    gap: 8px !important;
    padding: 12px 14px !important;
  }

  .form-card-actions ::v-deep .v-btn,
  .form-card-actions .btn-form-action {
    width: 100% !important;
    max-width: 100% !important;
    display: flex !important;
    justify-content: center !important;
    margin: 0 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .form-card-actions ::v-deep .v-btn + .v-btn {
    margin-left: 0 !important;
  }
}

/* ─── Notification Banner ─────────────────────────────────── */
.insp-notification {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 16px;
  font-size: 13px;
  line-height: 1.4;
  position: relative;
  z-index: 10;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.insp-notification--error {
  background: linear-gradient(90deg, #ffebee 0%, #fff5f5 100%);
  color: #b71c1c;
  border-left: 4px solid #e53935;
}

.insp-notification--warning {
  background: linear-gradient(90deg, #fff8e1 0%, #fffdf0 100%);
  color: #e65100;
  border-left: 4px solid #fb8c00;
}

.insp-notification--info {
  background: linear-gradient(90deg, #e3f2fd 0%, #f0f8ff 100%);
  color: #01579b;
  border-left: 4px solid #1e88e5;
}

.insp-notification__icon {
  flex-shrink: 0;
  margin-top: 1px;
  color: inherit !important;
}

.insp-notification__body {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.insp-notification__title {
  font-weight: 700;
  font-size: 13.5px;
}

.insp-notification__msg {
  font-size: 12.5px;
  opacity: 0.9;
}

.insp-notification__msg ::v-deep .insp-notif-item {
  display: block;
  margin-top: 2px;
  font-weight: 600;
}

.insp-notification__action {
  margin-top: 6px;
}

.insp-notification__action-btn {
  background: transparent;
  border: 1.5px solid currentColor;
  border-radius: 4px;
  color: inherit;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.3px;
  padding: 3px 10px;
  transition: background 0.2s, color 0.2s;
}

.insp-notification__action-btn:hover {
  background: currentColor;
  color: #fff;
}

.insp-notification__close {
  flex-shrink: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  color: inherit;
  opacity: 0.6;
  padding: 0;
  transition: opacity 0.2s;
  line-height: 1;
}

.insp-notification__close:hover {
  opacity: 1;
}

/* Slide-down transition */
.notif-slide-enter-active,
.notif-slide-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.notif-slide-enter,
.notif-slide-leave-to {
  max-height: 0;
  opacity: 0;
  padding-top: 0;
  padding-bottom: 0;
}

.notif-slide-enter-to,
.notif-slide-leave {
  max-height: 200px;
  opacity: 1;
}
</style>
